import React, {FC, useEffect, useState} from 'react'
import {
  getPlatformAdditionalInfoStatusAsync,
  getPlatformOwnerFieldsAsync,
  retrivePlatformDataAsync,
} from 'src/redux/actions/platformActions'
import {getFieldMappingAsync} from 'src/redux/actions/productActions'
import {useAppDispatch} from 'src/redux/storeHooks'
import {isSourceConnectedPlatform} from 'src/utils/platformConnectionValidation'
import {shouldPromptOwnerFieldMapping} from 'src/utils/platformAdditionalInfo'
import PlatformAdditionalMappingModal from './PlatformAdditionalMappingModal'

type Props = {
  selectedPlatformId?: string
  children: React.ReactNode
}

const PlatformAdditionalMappingGate: FC<Props> = ({selectedPlatformId, children}) => {
  const dispatch = useAppDispatch()
  const [showPlatformAdditionalInfo, setShowPlatformAdditionalInfo] = useState(true)

  useEffect(() => {
    if (!selectedPlatformId) return

    let cancelled = false

    const evaluateOwnerFieldPrompt = async () => {
      try {
        const [statusResponse, ownerFieldsResponse, platformResponse] = await Promise.all([
          dispatch(getPlatformAdditionalInfoStatusAsync({platform_id: selectedPlatformId})),
          dispatch(
            getPlatformOwnerFieldsAsync({platform_id: selectedPlatformId, field_id: ''})
          ),
          dispatch(retrivePlatformDataAsync({id: selectedPlatformId})),
        ])

        if (cancelled) return

        const platformDetail = platformResponse?.payload?.data ?? platformResponse?.payload

        let fieldMappingsPayload: unknown
        if (!isSourceConnectedPlatform(platformDetail)) {
          const fieldMappingsResponse = await dispatch(
            getFieldMappingAsync({destination_platform_id: selectedPlatformId})
          )
          if (fieldMappingsResponse?.meta?.requestStatus === 'fulfilled') {
            fieldMappingsPayload = fieldMappingsResponse.payload
          }
        }

        if (cancelled) return

        const shouldShowModal = shouldPromptOwnerFieldMapping({
          statusPayload: statusResponse?.payload,
          ownerFieldsPayload: ownerFieldsResponse?.payload,
          fieldMappingsPayload,
          platform: platformDetail,
        })

        setShowPlatformAdditionalInfo(!shouldShowModal)
      } catch {
        if (!cancelled) {
          setShowPlatformAdditionalInfo(true)
        }
      }
    }

    void evaluateOwnerFieldPrompt()

    return () => {
      cancelled = true
    }
  }, [dispatch, selectedPlatformId])

  return (
    <>
      {!showPlatformAdditionalInfo && selectedPlatformId && (
        <PlatformAdditionalMappingModal
          selectedPlatformId={selectedPlatformId}
          onComplete={() => setShowPlatformAdditionalInfo(true)}
        />
      )}
      {children}
    </>
  )
}

export default PlatformAdditionalMappingGate
